import styled from "styled-components";
import { Link } from "react-router-dom";
import { Typography } from "@atoms";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  
  width: 100%;
  padding: 18px 100px;
  background: rgba(89, 78, 71, 1);
`

export const MediaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  p {
    color: rgba(240, 229, 222, 1);
  }
`

export const MediaIcons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`

export const MediaIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  
  width: 32px;
  height: 32px;
  
  background: rgba(198, 166, 145, 1);
  border-radius: 4px;
`
export const Nav = styled.div`
  display: flex;
  flex-direction: row;
  gap: 48px;
`

export const StyledLink = styled(Link)`
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
  color: rgba(240, 229, 222, 1);
  text-decoration: none;

  &:active, &:hover {
    color: rgba(198, 166, 145, 1);
  }
  
  :active, :hover, :visited {
    font-size: inherit;
    font-family: inherit;
    font-weight: inherit;
    color: inherit;
  }
`

export const LegalInfo = styled.div`
  display: flex;
  flex-direction: column;
  text-align: right;
  gap: 8px;
  
  p {
    color: rgba(240, 229, 222, 1);
  }
`

export const Copyright = styled(Typography)`
  opacity: 0.5;
`
